class contratoArriendo {

    constructor(data) {
        this.contrato = data;
        this.sexoArrendador = this.contrato.arrendador.sexo === '1';
        this.sexoArrendatario = this.contrato.arrendatario.sexo === '1';
        this.dd = {
            //watermark: `No Valido`,
            header: [{
                text: 'Generado por Legiox.com.co',
                alignment: "right",
                margin: [15, 13, 14, 15],
                color: "black"
            },
            ],
            // background: 'Generado por Legiox.com.co',
            "content": [
                {
                    "text": "CONTRATO DE ARRENDAMIENTO DE VIVIENDA URBANA",
                    "style": "header",
                },
                {
                    text: [
                        `${this.contrato.arrendador.nombre}, con domicilio en la ciudad de ${this.contrato.arrendador.ciudadDomicilio}, identificad${this.sexoArrendador ? 'o' : 'a'} con la Cédula de\
 Ciudadanía Nro. ${this.contrato.arrendador.cedula} de ${this.contrato.arrendador.ciudadExpedicion}, quien obra en nombre propio y que para efectos de\
 este contrato se denominará `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `, por una parte, y por la otra, ${this.contrato.arrendatario.nombre}, con domicilio en la ciudad de ${this.contrato.arrendatario.ciudadDomicilio}, identificad${this.sexoArrendatario ? 'o' : 'a'} con la Cédula de\
 Ciudadanía Nro. ${this.contrato.arrendatario.cedula} de ${this.contrato.arrendatario.ciudadExpedicion}, quien para efectos de este contrato obra en nombre\
 propio y se denominará el `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, `, manifestaron que han\
 decidido celebrar un contrato de arrendamiento de bien inmueble destinado para\
 vivienda, el cual se rige por las siguientes cláusulas:`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `PRIMERA.- OBJETO DEL CONTRATO:`, "bold": true }, ` Por medio del presente Contrato, `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `\
 concede a título de arrendamiento a `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` del siguiente bien inmueble: \
 ${this.contrato.inmueble.tipo1}, que consta de ${this.contrato.inmueble.descripcion} y se encuentra ubicado en la ${this.contrato.inmueble.ubicacion} de la ciudad de ${this.contrato.inmueble.ciudad}, \
 destinado para el uso de vivienda urbana, para ${this.contrato.arrendatario.numeroPersonas} persona (s).
 Páragrafo: Garantía personal. Para garantizar el cumplimiento de todas y cada una de las obligaciones contraídas, la señora ${this.contrato.codeudor.nombre} identificada con cédula de ciudadanía ${this.contrato.codeudor.cedula} de ${this.contrato.codeudor.ciudadExpedicion} se compromete en calidad de codeudor, en igual proporción que LA ARRENDATARIA.
 `
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `SEGUNDA.- CANON DE ARRENDAMIENTO:`, "bold": true }, ` El canon de arrendamiento mensual será la suma de ${this.contrato.canon.valorLetras} pesos ($${this.contrato.canon.valorNumeros}) que `
                        , { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` pagará a `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `, en la ${this.contrato.canon.ubicacionPago}, dentro de los primeros ${this.contrato.canon.diaPago} \
 días de cada mes. El valor del canon de arrendamiento será reajustado en igual proporción al incremento del \
 Índice de Precios al Consumidor (IPC), sin exceder en todo caso el límite máximo de reajuste fijado por la ley. \
 El valor del canon de arrendamiento ${this.contrato.canon.administracion === '1' ? 'si' : 'no'} incluye las sumas causadas por cuotas de administración.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `TERCERA.- DURACIÓN:`, "bold": true }, ` El presente contrato tendrá una duración de ${this.contrato.termino.meses} meses contados a partir del ${this.contrato.termino.fechaInicioDia} de ${this.contrato.termino.fechaInicioMes} de ${this.contrato.termino.fechaInicioAno}.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `CUARTA.- PRORROGAS:`, "bold": true }, ` El término del arrendamiento se prorrogará automáticamente por periodos consecutivos \
 iguales al inicial, si ninguna de las partes ha manifestado a la otra, su intención de no continuar con el contrato \
 con (3) meses de antelación al vencimiento del término de duración.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `QUINTA.- ENTREGA: ${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` al momento de suscribir el presente contrato, declara recibir \
 el inmueble objeto en este acuerdo, de parte de `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, ` en perfecto estado, de conformidad \
 con el inventario elaborado por las partes y que forma parte integrante de este contrato.\
 `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, `, al momento en que termine este contrato, hará entrega del inmueble a \
 `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, ` en las mismas buenas condiciones en que lo recibió de `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `, \
 salvo el deterioro natural causado por el uso legítimo.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: 'SEXTA.- OBLIGACIONES:', "bold": true }, ` Las obligaciones para las partes serán, además de las\
 especificadas en este documento, las comunes a los contratos de arrendamiento,\
 las cuales son fijadas por los artículos 8 y 9 de la Ley 820 de 2003.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `SÉPTIMA.- SERVICIOS PÚBLICOS:`, "bold": true }, ` Los servicios públicos de acueducto, energía, gas ${this.contrato.canon.servicios === '1' ? 'están' : 'no están'} incluidos \
 dentro del canon de arrendamiento.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `OCTAVA.- PROHIBICIONES: ${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` no usará, el inmueble para el ocultamiento de personas, \
 depósito de armas o explosivos ni bienes de grupos armados al margen de la Ley, tampoco destinará el inmueble \
 para la elaboración, almacenamiento o venta de sustancias psicoactivas y/o alucinógenas, así como el \
 almacenamiento de sustancias o elementos considerados como peligrosos o de alto riesgo, que puedan poner en \
 peligro la integridad de las personas o el estado del inmueble. Del mismo modo queda prohibido  subarrendar o \
 ceder en todo o en parte los derechos conferidos por este contrato. `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` se \
 abstendrá de hacer mejoras de cualquier clase al  inmueble sin permiso previo y escrito de `
                        , { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}.`, "bold": true }
                    ],
                    style: "body"
                },
                {
                    text: [
                        `Lo anterior so pena de que `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, ` pueda dar por terminado el Contrato en forma \
 inmediata, sin lugar a indemnización alguna en favor de `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` y podrá exigir \
 la devolución del inmueble sin necesidad de ningún tipo de requerimiento previo por parte de `,
                        { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}.`, "bold": true }
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `NOVENA.- TERMINACIÓN:`, "bold": true }, ` El presente contrato podrá darse por terminado si cualquiera de las partes \
 ha manifestado con (3) meses de antelación al vencimiento del término de duración su intención por escrito \
 de no continuar con la relación contractual. Las partes podrán unilateralmente dar por terminado el \
 presente contrato, bajo cualquiera de las causales determinadas por los artículos 22 y 24 de la Ley 820 \
 de 2003. En todo momento, las partes, en cualquier tiempo, y de común acuerdo podrán dar por terminado \
 este contrato.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `DECIMA.- CESIÓN: ${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, ` faculta a `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, ` a ceder total \
 o parcialmente este Contrato y declara al cedente del Contrato, es decir a `, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `, \
 libre de cualquier responsabilidad como consecuencia de la cesión que haga de este Contrato.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `DECIMA PRIMERA.- MERITO EJECUTIVO:`, "bold": true }, ` Las partes reconocen y aceptan que este contrato presta merito ejecutivo.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `DECIMA SEGUNDA.- COSTOS:`, "bold": true }, ` Cualquier costo que se cause con ocasión de la celebración o prorroga \
 de este contrato, será asumido en su integridad por `, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}.`, "bold": true }
                    ],
                    style: "body"
                },
                {
                    text: [
                        { text: `DECIMA TERCERA.- CLÁUSULA PENAL:`, "bold": true }, ` En el evento de incumplimiento cualquiera de las partes a las \
 obligaciones a su cargo contenidas en la ley o en este contrato, la parte incumplida deberá pagar a \
 la otra parte una suma equivalente a (${this.contrato.canon.clausulaPenal}) cánones de arrendamiento vigentes en la fecha del \
 incumplimiento, a título de pena. En el evento que los perjuicios ocasionados por la parte incumplida, \
 excedan el valor de la suma aquí prevista como pena, la parte incumplida deberá pagar a la otra parte \
 la diferencia entre el valor total de los perjuicios y el valor de la pena prevista en esta cláusula.`
                    ],
                    style: "body"
                },
                {
                    text: [
                        `Para constancia el presente contrato es suscrito en la ciudad de ${this.contrato.termino.ciudad} el día ${this.contrato.termino.fechaFirmaDia} de ${this.contrato.termino.fechaFirmaMes} de ${this.contrato.termino.fechaFirmaAno} \
, en dos (2) ejemplares de igual valor, cada uno de ellos con destino a cada una de las partes.`
                    ],
                    style: "body"
                },
                {
                    columns: [
                        {
                            text: [`

`, { text: `${this.sexoArrendador ? 'EL' : 'LA'} ARRENDADO${this.sexoArrendador ? 'R' : 'RA'}`, "bold": true }, `
                            




${this.contrato.arrendador.nombre}
C.C. Nro. ${this.contrato.arrendador.cedula} de ${this.contrato.arrendador.ciudadExpedicion}
                            `]
                        },
                        {
                            text: [`

`, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} ARRENDATARI${this.sexoArrendatario ? 'O' : 'A'}`, "bold": true }, `
                            




${this.contrato.arrendatario.nombre}
C.C. Nro. ${this.contrato.arrendatario.cedula} de ${this.contrato.arrendatario.ciudadExpedicion} 
                            `]
                        },
                        {
                            text: [`

`, { text: `${this.sexoArrendatario ? 'EL' : 'LA'} CODEUDO${this.sexoArrendatario ? 'R' : 'RA'}`, "bold": true }, `
                            




${this.contrato.codeudor.nombre}
C.C. Nro. ${this.contrato.codeudor.cedula} de ${this.contrato.codeudor.ciudadExpedicion} 
                            `]
                        }

                    ]
                },
                {
                    text: [
                        ``
                    ],
                    style: "body"
                }
            ],
            "styles": {
                "header": {
                    "fontSize": 18,
                    "bold": true,
                    "alignment": "center"
                },
                "body": {
                    "fontSize": 12,
                    "bold": false,
                    "alignment": "justify",
                    "margin": [0, 5, 0, 5]
                }

            }
        }
    }
    getContractObject() {
        return this.dd;
    }
}
module.exports = contratoArriendo


// WEBPACK FOOTER //
// ./src/contractTemplates/arriendo.js